// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ede85bdf","977":"fa27b94c"}[chunkId] + ".chunk.js";
};